import type { ReactNode, ButtonHTMLAttributes } from 'react';
import styles from './ActionButton.module.css';

export type GlowCorner = 'tl' | 'tr' | 'bl' | 'br';

const GLOW_CLASS: Record<GlowCorner, string> = {
  tl: styles.glowTL,
  tr: styles.glowTR,
  bl: styles.glowBL,
  br: styles.glowBR,
};

export interface ActionButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  icon?: ReactNode;
  label: string;
  noGlow?: boolean;
  /** Compact inline variant — auto width, smaller height */
  compact?: boolean;
  /** Active/pressed state (inverted colors) */
  active?: boolean;
  /** Corner glow position on hover (compact only) */
  glow?: GlowCorner;
  /** Extra element after label (e.g. clear button) */
  suffix?: ReactNode;
}

export const ActionButton = ({ icon, label, disabled, noGlow, compact, active, glow, suffix, className, ...rest }: ActionButtonProps) => (
  <button
    className={`${styles.button} ${compact ? styles.compact : ''} ${active ? styles.active : ''} ${disabled ? styles.disabled : ''} ${noGlow ? styles.noGlow : ''} ${glow ? GLOW_CLASS[glow] : ''} ${className || ''}`}
    disabled={disabled}
    {...rest}
  >
    {icon}
    {label}
    {suffix}
  </button>
);

export default ActionButton;
